import { Skeleton, SkeletonProps } from '@chakra-ui/react';

export const Shimmer = ({ children, ...props }: SkeletonProps) => {
  return props.isLoaded ? <>{children}</> : <Skeleton h="22px" {...props} />;
};
